// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"522":"ae358abe","770":"0f42bd5c"}[chunkId] + ".chunk.js";
};